// extracted by mini-css-extract-plugin
module.exports = {"FranchizeFigure":"FranchizeFigure_FranchizeFigure__3mZWo","Description":"FranchizeFigure_Description__2Zyqa"};